export { default } from './RecordingWorkspace';
